export default "__VITE_ASSET__fdae3961__"